import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Servibalanzas</h3>
            <p>En Servibalanzas, nos especializamos en ofrecer un servicio técnico integral para una amplia gama de equipos de pesaje, desde balanzas de precisión hasta equipos de alto tonelaje utilizados en aplicaciones industriales.</p>
            <div className="social-links">
              <a href="mailto:contacto@servibalanzas.cl" className="social-link" aria-label="Email">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <rect x="3" y="5" width="18" height="14" rx="2" />
                  <path d="m3 7 9 6 9-6" />
                </svg>
              </a>
              <a href="tel:+56976234326" className="social-link" aria-label="Teléfono">
                <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                  <path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6A19.8 19.8 0 0 1 2.1 4.2 2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.96.3 1.9.6 2.8a2 2 0 0 1-.4 2.1L8 9.9a16 16 0 0 0 6 6l1.3-1.3a2 2 0 0 1 2.1-.4c.9.3 1.8.5 2.8.6a2 2 0 0 1 1.8 2.1Z" />
                </svg>
              </a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Servicios</h4>
            <ul>
              <li><Link to="/servicios#servicio-tecnico">Servicio Técnico</Link></li>
              <li><Link to="/servicios#obras-civiles">Obras Civiles</Link></li>
              <li><Link to="/servicios#desarrollo">Desarrollo</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Productos</h4>
            <ul>
              <li><Link to="/productos">Básculas Industriales</Link></li>
              <li><Link to="/productos">Sistemas de Pesaje</Link></li>
              <li><Link to="/productos">Equipos de Precisión</Link></li>
              <li><Link to="/productos">Accesorios</Link></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contacto</h4>
                        <div className="contact-info">
              <p><a href="tel:+56976234326" className="phone-link"> +56 9 7623 4326</a></p>
              <p><a href="mailto:contacto@servibalanzas.cl" className="email-link">contacto@servibalanzas.cl</a></p>
              <p>Santiago, Chile</p>
            </div>
            <a 
                              href="https://wa.me/+56976234326?text=Hola,%20me%20interesa%20conocer%20más%20sobre%20sus%20servicios%20de%20pesaje%20industrial" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn btn-secondary"
            >
              Contactar por WhatsApp
            </a>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; 2025 Servibalanzas. Todos los derechos reservados.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 
